import React, { useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Paper, Typography } from '@mui/material';
import { Visibility as ViewIcon } from '@mui/icons-material';
import { RESOURCES } from '../../hooks/usePermissions';
import { ledgerAPI } from '../../services/api';
import LedgerListPage from './LedgerListPage';

const AuditTrail = () => {
  const [selected, setSelected] = useState(null);
  return <>
    <LedgerListPage
      resource={RESOURCES.LEDGER.REPORTS}
      title="Accounting Audit Trail"
      subtitle="Read-only record of ledger entity changes, actors, and before/after values."
      idKey="audit_id"
      searchEnabled={false}
      emptyMessage="No audit events found."
      fetchItems={(params) => ledgerAPI.getAuditLogs(params)}
      filters={[
        { type: 'text', key: 'entity_type', label: 'Entity type' },
        { type: 'number', key: 'entity_id', label: 'Entity ID' },
      ]}
      columns={[
        { label: 'Recorded', render: (row) => new Date(row.created_at).toLocaleString() },
        { label: 'Entity', render: (row) => row.entity_type },
        { label: 'Entity ID', render: (row) => row.entity_id },
        { label: 'Action', render: (row) => row.action },
        { label: 'Actor', render: (row) => row.actor_id ?? 'System' },
      ]}
      rowActions={(row) => [{ icon: ViewIcon, title: 'View audit detail', onClick: () => setSelected(row) }]}
    />
    <Dialog open={!!selected} onClose={() => setSelected(null)} maxWidth="md" fullWidth>
      <DialogTitle>{selected?.action} · {selected?.entity_type} #{selected?.entity_id}</DialogTitle>
      <DialogContent>
        {selected && <>
          <Typography variant="body2" sx={{ mb: 2 }}>Recorded {new Date(selected.created_at).toLocaleString()} · actor {selected.actor_id ?? 'System'}</Typography>
          <Typography variant="subtitle2" fontWeight={700}>Before</Typography>
          <Paper variant="outlined" component="pre" sx={{ p: 1.5, whiteSpace: 'pre-wrap', overflowWrap: 'anywhere', maxHeight: 260, overflow: 'auto' }}>
            {selected.before == null ? '—' : JSON.stringify(selected.before, null, 2)}
          </Paper>
          <Typography variant="subtitle2" fontWeight={700} sx={{ mt: 2 }}>After</Typography>
          <Paper variant="outlined" component="pre" sx={{ p: 1.5, whiteSpace: 'pre-wrap', overflowWrap: 'anywhere', maxHeight: 260, overflow: 'auto' }}>
            {selected.after == null ? '—' : JSON.stringify(selected.after, null, 2)}
          </Paper>
        </>}
      </DialogContent>
      <DialogActions><Button onClick={() => setSelected(null)}>Close</Button></DialogActions>
    </Dialog>
  </>;
};

export default AuditTrail;
